module.exports = __webpack_public_path__ + "img/TBANK.7d294f33.png";